import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { Box, Popover } from "@material-ui/core";

import { editBookingPaymentStatus } from "../../../../../../../../general_redux/calendar/actions";
import styles from './PaymentStatusPopover.module.css';


const PaymentStatusPopover = (props) => {

    const dispatch = useDispatch();
    // const [marginLeft, setMarginLeft] = useState(-75);

    const {
        paymentStatus,
        setPaymentStatus,
        setPaymentStatusColor,
        getPaymentStatusColor,
        booking,
    } = props;

    const handlePaymentStatus = (paymentStatus, paymentStatusColor) => {
        setPaymentStatus(paymentStatus);
        setPaymentStatusColor(paymentStatusColor);

        // // adjust popover position
        // setMarginLeft(2);
        // if (paymentStatus === 'Paid') {
        //     setMarginLeft(-75)
        // };
        // if (paymentStatus == 'Partially Paid') {
        //     setMarginLeft(-28)
        // };
        // // end
    };

    const handleClosePopover = () => {
        props.onClose();
        setPaymentStatus(booking.paymentStatus);
        setPaymentStatusColor(getPaymentStatusColor(booking.paymentStatus));
    };

    const handleSubmit = () => {
        const payload = {
            id: booking?.id,
            paymentStatus: paymentStatus
        };
        dispatch(editBookingPaymentStatus(payload));
        // console.log(payload);
        handleClosePopover();
    };

    const CircleIcon = ({ color }) => (
        <div
            className={styles.circle}
            style={{ background: color }}
        />
    );

    useEffect(() => {
        handlePaymentStatus(booking.paymentStatus, getPaymentStatusColor(booking.paymentStatus));
    }, []);

    return (
        <Popover
            id={props.id}
            open={props.open}
            onClose={handleClosePopover}
            anchorEl={props.anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            PaperProps={{
                style: {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    borderRadius: 0,
                    display: "flex",
                    overflow: "visible",
                    marginTop: -25,
                    marginLeft: -75,
                    // marginLeft: marginLeft,
                }
            }}
        >
        <main className={styles.modalBody}>
            <Box
                className={styles.leftArrow}
            />
            <div className={styles.container}>
                <div onClick={() => handlePaymentStatus('Paid', '#439a86')} className={styles.optionButton}>
                    <CircleIcon color={'#439a86'} /><div className={styles.text}>Paid</div>
                </div>
                <div onClick={() => handlePaymentStatus('Partially Paid', '#f5b60e')} className={styles.optionButton}>
                    <CircleIcon color={'#f5b60e'} /><div className={styles.text}>Partially Paid</div>
                </div>
                <div onClick={() => handlePaymentStatus('Payment Pending', '#dc3545')} className={styles.optionButton}>
                    <CircleIcon color={'#dc3545'} /><div className={styles.text}>Payment Pending</div>
                </div>
            </div>
            <button onClick={handleSubmit} className={styles.submitButton}>
                Save
            </button>
        </main>
        </Popover>
    );
};

export default PaymentStatusPopover;